import {onMounted} from "vue";
import {useRoute} from "vue-router";

export default function useCleanHash() {
  const route = useRoute();
  onMounted(() => {
    const hash = route.hash;
    if (hash.endsWith("/") && hash.length > 1) {
      const cleanHash = hash.replace(/\/+$/, "");
      const {pathname, search} = window.location;
      const newUrl = `${pathname}${search}${cleanHash}`;
      history.replaceState(null, "", newUrl);
    }
  });
}
